import React from 'react'
import { View } from '@/components'
import { createStyles } from '@codeleap/styles'
import { getReactionEmoji } from '@packages/chat'

export type EmojiProps = {
  emoji: string
  isSelected?: boolean
  size?: number
  onPress?: (emoji: string) => void
  style?: React.CSSProperties
  debugName?: string
  isReactionPicker?: boolean
}

export const Emoji = ({
  emoji,
  isSelected,
  size = 24,
  onPress,
  style,
  debugName,
  isReactionPicker,
}: EmojiProps) => {
  const handleClick = () => {
    if (onPress) {
      onPress(emoji)
    }
  }

  return (
    <div
      onClick={handleClick}
      style={{
        ...styles.wrapper,
        cursor: onPress ? 'pointer' : 'default',
        pointerEvents: onPress ? 'auto' : 'none',
        ...style,
      }}
      data-debug={debugName}
      data-testid={debugName ? debugName.replace(/\s+/g, '_').toLowerCase() : undefined}
    >
      {isSelected && <View style={[styles.selectedEmoji, isReactionPicker && { top: '-6px' }]} />}

      <span
        style={{
          fontSize: size,
          textAlign: 'center',
          lineHeight: `${size}px`,
        }}
      >
        {getReactionEmoji(emoji)}
      </span>
    </div>
  )
}

const styles = createStyles((theme) => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  selectedEmoji: {
    backgroundColor: theme.colors.buttonSubtlePrimaryBgHover,
    position: 'absolute',
    width: 40,
    height: 40,
    borderRadius: theme.radius.infinite,
    opacity: 0.15,
  },
}))
